<template>
    <div class="">
        <div class="row">
            <div class="col-4">

            </div>
            <div class="col-4 text-center">
                <div><strong>Заказ № {{order.SferaNumber}}</strong></div>
                <div>Внутренний номер: {{order.LocalNumber ? order.LocalNumber : '-'}}</div>
            </div>
            <div class="col-4 text-right">
                <vue-barcode :value="order.SferaNumber" width="2" height="40" display-value="false">
                    Ошибка штрихкода
                </vue-barcode>
            </div>
            <div class="col-6">
                <ul class="list-unstyled m-0">
                    <li><strong>{{order.PartnerPriceName.Sku}}</strong></li>
                    <li>Дополнительно: <strong>{{order.Dops}}</strong></li>
                    <li>Цена: <strong>{{order.Price}}</strong></li>
                    <li>Кол-во: <strong>{{order.Amount}}</strong></li>
                    <li>Сумма: <strong>{{order.Summary}}</strong></li>
                </ul>
            </div>
            <div class="col-6">
                <ul class="list-unstyled m-0">
                    <li>Принят: <strong>{{order.OrderCommon.ReceivedDate}}</strong></li>
                    <li>Партнер: <strong>{{order.Partner.Reception}}</strong></li>
                    <li>Объезд: <strong>{{order.Partner.PartnerTour.Name}}</strong></li>
                    <li>Дата готовности: <strong>{{order.OrderCommon.ReadyDate}}</strong></li>
                </ul>
            </div>
            <div class="col-12">
                Примечание: {{order.Comment}}
            </div>
        </div>
    </div>
</template>
<script>
import VueBarcode from 'vue-barcode';

export default {
  props: ['order'],
  components: {
    VueBarcode,
  },
  methods: {},
};
</script>
<style>

</style>
